import DateInput from "components/Common/DateInput"
import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Col, Input, Label, Row, Table } from "reactstrap"

export default function index(props) {
  const {
    supplierId,
    supplierIds,
    orderDetailDisabled,
    year,
    season,
    seasons,
    payload,
    productId,
    productIds,
    onSizeChange,
    handleInput,
    sums,
    setProductId,
    nTimesPrice,
  } = props.config

  return (
    <Row>
      <Col xl={4} sm={4}>
        <p>RTW受注詳細</p>
        <Table bordered responsive>
          <tbody>
            <tr>
              <th style={{ minWidth: 105 }}>お取引先様</th>
              <td>
                <SelectBox
                  options={supplierIds}
                  value={supplierId}
                  onChange={v => {
                    handleInput({ val: v, type: "supplierId" })
                    setProductId("")
                  }}
                  // isDisabled={orderDetailDisabled}
                />
              </td>
            </tr>
            <tr>
              <th>ご担当者さま</th>
              <td>
                <Input
                  type="text"
                  name="picName"
                  value={payload.picName}
                  onChange={e => handleInput({ e, type: "picName" })}
                />
              </td>
            </tr>
            <tr>
              <th>年度</th>
              <td>
                <SelectBox
                  options={[
                    { value: "22", label: "2022" },
                    { value: "23", label: "2023" },
                    { value: "24", label: "2024" },
                    { value: "25", label: "2025" },
                    { value: "26", label: "2026" },
                    { value: "27", label: "2027" },
                    { value: "28", label: "2028" },
                    { value: "29", label: "2029" },
                    { value: "30", label: "2030" },
                  ]}
                  value={year}
                  onChange={v => handleInput({ val: v, type: "year" })}
                  // isDisabled={orderDetailDisabled}
                />
              </td>
            </tr>
            <tr>
              <th>シーズン</th>
              <td>
                <SelectBox
                  options={seasons}
                  value={season}
                  onChange={v => handleInput({ val: v, type: "seasonId" })}
                  // isDisabled={orderDetailDisabled}
                />
              </td>
            </tr>
            <tr>
              <th>注文日</th>
              <td>
                <DateInput
                  // value={payload.orderDate}
                  onChange={([e]) => handleInput({ e, type: "orderDate" })}
                  className="form-control"
                />
              </td>
            </tr>
            <tr>
              <th>納品予定日</th>
              <td>
                <DateInput
                  onChange={([e]) =>
                    handleInput({ e, type: "scheduledDeliveryDate" })
                  }
                  className="form-control"
                />
              </td>
            </tr>
            <tr>
              <th>発注書No.</th>
              <td>
                <Input type="text" disabled />
              </td>
            </tr>
            <tr>
              <th>発注種類</th>
              <td className="d-flex flex-column">
                {/* <div>
                  <Input
                    name="type"
                    id="アトリエメイド"
                    value="アトリエメイド"
                    type="radio"
                    className="me-2"
                    onClick={e => handleInput({ e, type: "type" })}
                  />
                  <Label htmlFor="アトリエメイド">アトリエメイド</Label>
                </div> */}
                <div>
                  <Input
                    name="type"
                    id="ファクトリーメイド"
                    type="radio"
                    className="me-2"
                    value={payload.type === "ファクトリーメイド"}
                    checked={payload.type === "ファクトリーメイド"}
                    onClick={e => handleInput({ e, type: "type" })}
                  />
                  <Label htmlFor="ファクトリーメイド">ファクトリーメイド</Label>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </Col>
      <Col xl={8} sm={8}>
        <Label htmlFor="productId">商品番号を選択してください</Label>

        <Row className="mb-3">
          <Col sm={4}>
            <SelectBox
              options={productIds}
              value={productId}
              id="productId"
              onChange={v => handleInput({ val: v, type: "productId" })}
              isDisabled={!payload.supplierId}
            />
          </Col>
          <Col
            sm={2}
            className="d-flex justify-content-center align-items-center"
          >
            <div className="d-flex">
              <Input
                type="checkbox"
                id="新規商品"
                name="newProduct"
                className="me-2"
                defaultChecked={payload.newProduct}
                onChange={e => handleInput({ e, type: "newProduct" })}
              />
              <Label htmlFor="新規商品">新規商品</Label>
            </div>
          </Col>
          <Col>
            <Input
              type="text"
              placeholder="商品名"
              name="productName"
              value={payload.productName}
              onChange={e => handleInput({ e, type: "productName" })}
              disabled={orderDetailDisabled}
            />
          </Col>
        </Row>
        <Table bordered className="mb-3">
          <tbody>
            <tr>
              <td style={{ width: 105 }}>サンプル</td>
              <td>
                <Input
                  type="checkbox"
                  id="サンプル"
                  className="me-2"
                  name="sample"
                  onChange={e => handleInput({ e, type: "sample" })}
                />
                <Label htmlFor="サンプル"> サンプル</Label>
              </td>
            </tr>
          </tbody>
        </Table>
        <Table bordered responsive>
          <thead>
            <tr>
              <td style={{ minWidth: 105 }}></td>
              <th>order size assort</th>
              <th>単価</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-center">42</td>
              <td>
                <Input
                  type="number"
                  name="orderQty"
                  data-size={42}
                  value={payload.sizes[0].orderQty}
                  onChange={onSizeChange}
                />
              </td>
              <td>
                <Input
                  type="number"
                  name="unitPrice"
                  data-size={42}
                  value={payload.sizes[0].unitPrice}
                  onChange={onSizeChange}
                />
              </td>
            </tr>
            <tr>
              <td className="text-center">44</td>
              <td>
                <Input
                  type="number"
                  name="orderQty"
                  data-size={44}
                  value={payload.sizes[1].orderQty}
                  onChange={onSizeChange}
                />
              </td>
              <td>
                <Input
                  type="number"
                  name="unitPrice"
                  data-size={44}
                  value={payload.sizes[1].unitPrice}
                  onChange={onSizeChange}
                />
              </td>
            </tr>
            <tr>
              <td className="text-center">46</td>
              <td>
                <Input
                  type="number"
                  name="orderQty"
                  data-size={46}
                  value={payload.sizes[2].orderQty}
                  onChange={onSizeChange}
                />
              </td>
              <td>
                <Input
                  type="number"
                  name="unitPrice"
                  data-size={46}
                  value={payload.sizes[2].unitPrice}
                  onChange={onSizeChange}
                />
              </td>
            </tr>
            <tr>
              <td className="text-center">48</td>
              <td>
                <Input
                  type="number"
                  name="orderQty"
                  data-size={48}
                  value={payload.sizes[3].orderQty}
                  onChange={onSizeChange}
                />
              </td>
              <td>
                <Input
                  type="number"
                  name="unitPrice"
                  data-size={48}
                  value={payload.sizes[3].unitPrice}
                  onChange={onSizeChange}
                />
              </td>
            </tr>
            <tr>
              <td className="text-center">50</td>
              <td>
                <Input
                  type="number"
                  name="orderQty"
                  data-size={50}
                  value={payload.sizes[4].orderQty}
                  onChange={onSizeChange}
                />
              </td>
              <td>
                <Input
                  type="number"
                  name="unitPrice"
                  data-size={50}
                  value={payload.sizes[4].unitPrice}
                  onChange={onSizeChange}
                />
              </td>
            </tr>
            <tr>
              <td className="text-center">52</td>
              <td>
                <Input
                  type="number"
                  name="orderQty"
                  data-size={52}
                  value={payload.sizes[5].orderQty}
                  onChange={onSizeChange}
                />
              </td>
              <td>
                <Input
                  type="number"
                  name="unitPrice"
                  data-size={52}
                  value={payload.sizes[5].unitPrice}
                  onChange={onSizeChange}
                />
              </td>
            </tr>
            <tr>
              <td className="text-center">54</td>
              <td>
                <Input
                  type="number"
                  name="orderQty"
                  data-size={54}
                  value={payload.sizes[6].orderQty}
                  onChange={onSizeChange}
                />
              </td>
              <td>
                <Input
                  type="number"
                  name="unitPrice"
                  data-size={54}
                  value={payload.sizes[6].unitPrice}
                  onChange={onSizeChange}
                />
              </td>
            </tr>
            <tr>
              <td className="text-center" style={{ minWidth: 105 }}>
                合計
              </td>
              <td className="text-center">{sums}</td>
              <td className="text-center">{nTimesPrice}</td>
            </tr>
          </tbody>
        </Table>
      </Col>
    </Row>
  )
}
